import Vue from 'vue';
import Vuex from 'vuex';
// import * as Sentry from '@sentry/browser';
import createPersistedState from "vuex-persistedstate";
import {APIVars} from '../config';
import axios from 'axios';

//import SecureLS from "secure-ls";
//var ls = new SecureLS({ isCompression: true });

// https://github.com/robinvdvleuten/vuex-persistedstate
// https://github.com/softvar/secure-ls

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    wing: '',
    userinfo: {
      cognitoInfo: {},
      loggedIn: false,
      loadingState: true,
      errorLoadingState: false,
      wing:'',
      capid: null
    },
    MenuPermissions:{
      Menu_AircraftInfo:['CAWG'],
      Menu_Callsigns:['CAWG'],
      Menu_CheckPilots:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_Covid19:['CAWG'],
      Menu_Form14:['CAWG'],
      Menu_FROList:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_ICList:['CAWG'],
      Menu_MemberInfo:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_MishapReport:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_MyInfo:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_StaffList:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_Told:['CAWG'],
      Menu_WMAO:['CAWG'],
      Menu_Login:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_Logout:['CAWG','HIWG','NVWG','ORWG','WAWG','AKWG'],
      Menu_PosRpt:['CAWG'],
      Menu_SpecDC:['CAWG'],
      Menu_SkillEvaluator:['CAWG'],
      Menu_SpecialtyTracks:['CAWG'],
    },
    UnitsWithGroups:['CAWG'],
    userPerms: {
      wing: '',
      isAdmin: false,
      isAEAdmin: false,
      isCPAdmin: false,
      isOPSAdmin: false,
      isESAdmin: false,
      FirstName: '',
      LastName: '',
      EmailAddress: '',
      isAuthenticated: false,
      userOid: '',
      stateDatetime:''
    },
    userDefaultSettings: {
      defaultAirportID: ''
    },
    appSettings: {
      backButtonVisible: false,
      homeButtonVisible: false,
      previousRoute: null
    },
    tempUnits: [],
    tempZones: [],
    tempICList: [],
    tempAircraftList:[],
    tempAircraftMxList:[],
    tempFROList: [],
    tempCheckPilotTypes: [],
    tempCheckPilotList: [],
    tempCallSignSearch: {
      callsign: "",
      name: "",
      type: "",
      id: "",
      wing: ""
    },
    globalIndex: 0,
    appUpdateNeeded: false
  },
  plugins: [createPersistedState({
    key: 'prma',
    //storage: sessionStorage
  })],
  mutations: {
    SET_USERINFO: (state, payload) => {
      state.userinfo = payload;
    },
    setBackButtonVisibility: (state, payload) => {
      state.appSettings.backButtonVisible = payload;
    },
    setPreviousRoute: (state, payload) => {
      state.appSettings.previousRoute = payload.previousRoute;
    },
    setHomeButtonVisibility: (state, payload) => {
      state.appSettings.homeButtonVisible = payload;
    },
    setUnitList: (state, payload) => {
      state.tempUnits = payload;
    },
    setZoneList: (state, payload) => {
      state.tempZones = payload;
    },
    setICList: (state, payload) => {
      state.tempICList = payload;
    },
    setAircraftList: (state, payload) => {
      state.tempAircraftList = payload;
    },
    setAircraftMxList: (state, payload) => {
      state.tempAircraftMxList = payload;
    },
    setFROList: (state, payload) => {
      state.tempFROList = payload;
    },
    setTempCallsignSearch: (state, payload) => {
      state.tempCallSignSearch = payload;
    },
    setCheckPilotTypes: (state, payload) => {
      state.tempCheckPilotTypes = payload;
    },
    setCheckPilotList: (state, payload) => {
      state.tempCheckPilotList = payload;
    },
    setLoggedIn: (state, payload) => {
      state.userinfo.loggedIn = payload;
    },
    setGlobalIndex: (state, payload) => {
      state.globalIndex = payload;
    },
    setCognitoInfo: (state,payload) => {

      //console.log(payload)

      if(payload.email != null && payload.email != undefined)
      {
        //console.log('Inside if statement')
        var emailAddress = (payload.email).toString().toLowerCase();

        // Sentry.configureScope(function(scope) {
        //   scope.setUser({"email": emailAddress});
        // });

        if((emailAddress.includes("cawg")) > -1)
        {
          //console.log('CAWG');
          payload.wing = 'CAWG';
        }

        if((emailAddress.search("nvwg")) > -1)
        {
          //console.log('NVWG');
          payload.wing = 'NVWG';
        }

        if((emailAddress.search("orwg")) > -1)
        {
          //console.log('ORWG');
          payload.wing = 'ORWG';
        }

        if((emailAddress.search("hiwg")) > -1)
        {
          //console.log('ORWG');
          payload.wing = 'HIWG';
        }

        var req = {
          wing: payload.wing,
          upn: emailAddress
        };

        axios.post(APIVars.BaseUrl + APIVars.GetCapidFromUpnRoute, req, APIVars.config)
        .then(response => {

          var capid = response.data;
          state.userinfo.capid = capid.toString();

        })
        .catch(e => {
          console.log(e);
          //this.isLoading = false;
        });

      }
      else{
        payload.wing = 'NONE';
      }

      state.userinfo.cognitoInfo = payload;

    },
    updateAppUpdatedNeededVar: (state,payload) => {
      state.appUpdateNeeded = payload;
    },
    updateSelWing: (state,payload) => {
      state.wing = payload;
    }
  },
  actions: {
    updateLoggedIn: (context,payload) => {
      context.commit('setLoggedIn',payload);
    },
    updateCognitoInfo: (context,payload) => {

      context.commit('setCognitoInfo',payload);
    },
    updateWing: (context) => {
      context.commit('setWing');
    },
    updatePreviousRoute: (context) => {
      context.commit('setPreviousRoute');
    },
    updateBackButtonVisibility: (context,payload) => {
      context.commit('setBackButtonVisibility',payload);
    },
    updateHomeButtonVisibility: (context,payload) => {
      context.commit('setHomeButtonVisibility',payload);
    },
    updateUnitList: (context,payload) => {
      context.commit('setUnitList',payload);
    },
    updateZoneList: (context,payload) => {
      context.commit('setZoneList',payload);
    },
    updateICList: (context,payload) => {
      context.commit('setICList',payload);
    },
    updateAircraftList: (context,payload) => {
      context.commit('setAircraftList',payload);
    },
    updateAircraftMxList: (context,payload) => {
      context.commit('setAircraftMxList',payload);
    },
    updateFROList: (context,payload) => {
      context.commit('setFROList',payload);
    },
    updateCheckPilotTypes: (context,payload) => {
      context.commit('setCheckPilotTypes',payload);
    },
    updateCallsignSearch: (context, payload) => {
      context.commit('setTempCallsignSearch', payload);
    },
    updateCheckPilotList: (context,payload) => {
      context.commit('setCheckPilotList',payload);
    },
    updateGlobalIndex: (context,payload) => {
      context.commit('setGlobalIndex',payload);
    },
    updateAppUpdateNeededVar: (context, payload) => {
      context.commit('updateAppUpdateNeededVar', payload);
    },
    updateSelWing: (context, payload) => {
      context.commit('updateSelWing', payload);
    }
  },
  getters: {
    getGlobalIndex: state => {
      return state.globalIndex;
    },
    getPreviousRoute: state => {
      return state.appSettings.previousRoute;
    }
  },
  modules: {
  },
});
